import * as types from '../types'
import axios from 'axios'

const state = {
  loadingOrderDetails: false,
  orderDetails: {
    reference: null,
    restmaterials: null,
    orderDate: null,
    deliveryAddress: null,
    deliveryDate: null,
    deliveryPrice: 0,
    price: 0,
    vat: 0,
    cart: []
  }
}

const getters = {
  loadingOrderDetails: (state) => {
    return state.loadingOrderDetails
  },
  orderDetails: (state) => {
    return state.orderDetails
  }
}

const mutations = {
  [types.MUTATE_LOADING_ORDER_DETAILS]: (state, loadingOrderDetails) => {
    state.loadingOrderDetails = loadingOrderDetails
  },
  [types.MUTATE_ORDER_DETAILS]: (state, orderDetails) => {
    state.orderDetails = orderDetails
  }
}

const actions = {
  [types.FETCH_ORDER_DETAILS]: ({ commit, state, dispatch }, orderId) => {
    commit(types.MUTATE_LOADING_ORDER_DETAILS, true)

    axios
      .get('/order/details/' + orderId)
      .then(res => {
        commit(types.MUTATE_ORDER_DETAILS, res.data)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_LOADING_ORDER_DETAILS, false)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
